import React from 'react';
import {RegisterOptions} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import {validateMultipleUrls} from 'shared/lib/validation/validateUrl';

import TextArea, {TextAreaProps} from './TextArea';

const TextAreaUrl: React.FC<TextAreaProps> = (props) => {
    const rules: RegisterOptions = {
        validate: validateMultipleUrls,
        required: t`Укажите хотя бы один URL`,
    };

    return (
        <TextArea
            constraints={rules}
            {...props}
        />
    );
};

export default TextAreaUrl;